import { Redirect, useParams } from "react-router-dom";

const PersonalIntegrationRouteRedirect = () => {
  const { slug } = useParams<{ slug: string }>();
  return <Redirect to={`/account/integrations?open=${slug}`} />;
};

export default PersonalIntegrationRouteRedirect;
